import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAILURE,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAILURE,
  CLEAR_AUTH_STATE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  CLEAR_MESSAGE_ERROR,
  SET_IS_BOARDED,
  FETCH_USER,
  REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILURE,
  VERIFY_OTP,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  RESEND_OTP,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  UPDATE_USER_PROFILE_SUCCESS
} from "../actions/types";

const initialState = {
  user: null, // Contains { token, user }
  loading: false,
  error: null,
  passwordResetRequested: false,
  passwordResetSuccess: false,
  message: "",
  otpRequested: false,
  otpVerified: false,
  pendingEmail: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
    case SIGNUP_REQUEST:
    case REQUEST_OTP:
    case VERIFY_OTP:
    case RESEND_OTP:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: null,
        otpRequested: false,
        otpVerified: true,
      };

    case FETCH_USER:
      return {
        ...state,
        loading: false,
        user: action.payload,
        error: null,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case LOGIN_FAILURE:
    case SIGNUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        user: null,
        otpRequested: false,
        otpVerified: false,
        pendingEmail: null
      };
      
    // OTP related cases
    case REQUEST_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpRequested: true,
        pendingEmail: action.payload.email || state.pendingEmail,
        message: "Code de vérification envoyé par email.",
        error: null,
      };
      
    case REQUEST_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        otpRequested: false,
      };
      
    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpVerified: true,
        user: action.payload,
        pendingEmail: null,
        error: null,
      };
      
    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        otpVerified: false,
      };
      
    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        message: "Nouveau code de vérification envoyé par email.",
        error: null,
      };
      
    case RESEND_OTP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        message: null,
      };
      
    case FORGOT_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        passwordResetRequested: false,
        passwordResetSuccess: false,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        passwordResetRequested: true,
        message: action.payload,
        error: null,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        passwordResetSuccess: true,
        message: action.payload,
        error: null,
      };
    case FORGOT_PASSWORD_FAILURE:
    case RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        passwordResetRequested: false,
        passwordResetSuccess: false,
      };
    case CLEAR_AUTH_STATE:
      return initialState;
    case CLEAR_MESSAGE_ERROR: // Handle the new action
      return {
        ...state,
        message: "",
        error: null,
      };

    case SET_IS_BOARDED:
      return {
        ...state,
        user: {
          ...state.user,
          user: {
            ...state.user.user,
            is_boarded: action.payload,
          },
        },
      };

    case UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          user: {
            ...state.user.user,
            first_name: action.payload.first_name,
            last_name: action.payload.last_name,
            phone_number: action.payload.phone_number,
            user_type: action.payload.user_type,
            organization_name: action.payload.organization_name ?? state.user.user.organization_name,
            is_boarded: true,
          },
        },
      };

    default:
      return state;
  }
};

export default authReducer;
